import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
    DEFAULT_REQUEST_REASONS,
    FilterConfig,
    INNITIAL_REQUEST_REASON,
    RequestReason,
    VISITORS_REQUEST_REASONS
} from '../employee-badge-requests';
import * as EmployeeModels from '@employee-models/index';
import {CustomModalService} from '@ui-app/services/custom-modal.service';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {NameChangeModalComponent} from 'DBadgeEmployee-app/src/app/modals/name-change-modal/name-change-modal.component';
import {ResponsiveService} from '@ui-app/services/responsive.service';
import {BadgeDamagedModalComponent} from '../../../modals/badge-damaged-modal/badge-damaged-modal.component';
import {LOCATION_FILTER_CONFIG} from '@employee-pages/badge-request-page/user-rules';
import {BadgeReasonEnum} from '@employee-models/data.enums';
import { IPPMDSearchInMyLocationResult } from '@employee-models/data.models';
import { BadgeLostModalComponent } from 'DBadgeEmployee-app/src/app/modals/badge-lost-modal/badge-lost-modal.component';
import { BadgeTypeSelectionModalComponent } from 'DBadgeEmployee-app/src/app/modals/badge-type-selection-modal/badge-type-selection-modal.component';
import { GridNonDeloitteComponent } from '../non-deloitte-visitors/grid-non-deloitte/grid-non-deloitte.component';
import { GuestGridComponent } from '../employee-member-firm-visitor/guest-grid/guest-grid.component';
import { ContractorGridComponent } from '../3rd-party-contractors/contractor-grid/contractor-grid.component';


@Component({
    selector: 'employee-request-details',
    templateUrl: './employee-request-details.component.html',
    styleUrls: ['./employee-request-details.component.less']
})

export class EmployeeRequestDetailsComponent implements OnInit, OnChanges {

    @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() requestReasonPayload: EmployeeModels.CM.IBadgeRequestPayloadModel;
    @Input() isPPMD: boolean;
    @Output() onRequestReasonSelect: EventEmitter<EmployeeModels.CM.IBadgeRequestPayloadModel> = new EventEmitter();
    @Output() onPPMDUserSelected: EventEmitter<IPPMDSearchInMyLocationResult> = new EventEmitter();
    @ViewChild(GridNonDeloitteComponent) gridNonDeloitteComponent: GridNonDeloitteComponent;
    @ViewChild(GuestGridComponent) guestGridComponent: GuestGridComponent;
    @ViewChild(ContractorGridComponent) contractorGridComponent: ContractorGridComponent;
    // isBadgeExtension: boolean = false;
    @Output() openNonDeloitteGuestForm = new EventEmitter<{ isBadgeExtension: boolean }>();
    @Output() openMemberFirmGuestForm = new EventEmitter<{ isBadgeExtension: boolean }>();
    @Output() openContractorGuestForm = new EventEmitter<{ isBadgeExtension: boolean }>();
    @Output() openCleGuestForm = new EventEmitter<{ isBadgeExtension: boolean }>();

    readonly locationFilterConfig: FilterConfig = LOCATION_FILTER_CONFIG;
    tabs: RequestReason[];
    visitorsTabs: RequestReason[];
    subs: Subscription;
    isDesktop: boolean;
    showBadgeTypePopup: boolean = false;
    badgeFormType: 'initial' | 'extension' = 'initial';
    selectedVisitorTab: RequestReason | null = null;

    constructor(
        private customModalService: CustomModalService,
        private responsiveService: ResponsiveService
    ) {
    }

    ngOnInit(): void {
        this.responsiveService.isDesktop.subscribe(data => this.isDesktop = data);
        }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.requestData && changes.requestData.currentValue) {
            switch (this.requestData.badgeRequestType) {
                case EmployeeModels.DE.BadgeRequestTypeEnum.MissingPhoto:
                    this.tabs = INNITIAL_REQUEST_REASON;
                    this.requestReasonPayload.reason = BadgeReasonEnum.InitialBadgeRequest;
                    this.requestReasonPayload.isChanges = false;
                    this.onRequestReasonSelect.emit(this.requestReasonPayload);
                    break;
                case EmployeeModels.DE.BadgeRequestTypeEnum.Resubmission:
                    this.tabs = [...INNITIAL_REQUEST_REASON, ...DEFAULT_REQUEST_REASONS].filter(tab => {
                        return tab.categoryId === this.requestReasonPayload.reason;
                    });
                    break;
                default:
                    this.tabs = DEFAULT_REQUEST_REASONS;
                    this.visitorsTabs = VISITORS_REQUEST_REASONS;
                    break;
            }
        }
    }

    locationChanged(siteId: number): void {
        this.requestReasonPayload.deliverySiteId = siteId;
        this.requestReasonPayload.isChanges = true;
        this.onRequestReasonSelect.emit(this.requestReasonPayload);
    }

    pickRequestReason(tab: RequestReason): void {
        // Visitor categories: 3rd party: 3, member firm: 4, non-Deloitte: 5
        if ([3, 4, 5, 8].includes(tab.categoryId)) {
            this.selectedVisitorTab = tab;
            this.subs = this.customModalService.initModal(BadgeTypeSelectionModalComponent, {}, 'modal-xs')
                .pipe(filter(Boolean))
                .subscribe((type: 'initial' | 'extension') => {
                    this.badgeFormType = type;
                    const isBadgeExtension = type === 'extension';
                    // Open the correct visitor form and pass the flag
                    tab.isExtension = isBadgeExtension;
                    if (tab.categoryId === 3) {
                    this.openContractorGuestForm.emit({ isBadgeExtension });
                    } else if (tab.categoryId === 4) {
                        this.openMemberFirmGuestForm.emit({ isBadgeExtension });
                    } else if (tab.categoryId === 5) {
                    // Non-Deloitte: emit event to parent instead of calling grid directly
                    this.openNonDeloitteGuestForm.emit({ isBadgeExtension });
                  } else if (tab.categoryId === 8) {
                    this.openCleGuestForm.emit({ isBadgeExtension });
                  }
                    if (this.selectedVisitorTab) {
                        this.updateRequestReasonPayload(this.selectedVisitorTab);
                    }
                });
            return;
        }
        const isUSI = this.requestData.country === EmployeeModels.CE.BadgeRequestCountry.USI;
        const isUS = this.requestData.country === EmployeeModels.CE.BadgeRequestCountry.US;
        switch (tab.reasonId) {
            case 0:
                this.openNameChangeModal();
                break;
            case 1:
                if (isUSI) {
                    this.openBadgeDamageModal();
                    break;
                }
                this.updateRequestReasonPayload(tab);
                break;
            case 2:
            case 3:
                if (isUS || isUSI) {
                    this.openBadgelostModal(tab.reasonId);
                }
                // Fallthrough to update payload
            default:
                this.updateRequestReasonPayload(tab);
                break;
        }
    }

    ppmdUserSelected(user: IPPMDSearchInMyLocationResult): void {
        if(user?.isPrehire){
            this.tabs = INNITIAL_REQUEST_REASON;
        }
        this.onPPMDUserSelected.emit(user);
    }
    private updateRequestReasonPayload(tab: RequestReason): void {
        this.requestReasonPayload.reason = tab.reasonId;
        this.requestReasonPayload.category = tab.categoryId;
        this.requestReasonPayload.isChanges = true;
        this.requestReasonPayload.isExtension = tab.isExtension;
        this.onRequestReasonSelect.emit(this.requestReasonPayload);
    }

    preferredFullNameSelected(isPreferredFullName: boolean): void {
        this.requestReasonPayload.isPreferredFullName = isPreferredFullName;
        this.requestReasonPayload.isNameChanges = true;
        this.onRequestReasonSelect.emit(this.requestReasonPayload);
    }

    bloodGroupSelected(bloodGroupName: string): void {
        this.requestReasonPayload.bloodGroupId = this.requestData.bloodGroups
            .find(r => r.bloodGroupName === bloodGroupName)?.bloodGroupId;

        this.requestReasonPayload.isChanges = true;
        this.onRequestReasonSelect.emit(this.requestReasonPayload);
    }

    openNameChangeModal(): void {
        const isUSI = this.requestData.country === EmployeeModels.CE.BadgeRequestCountry.USI;
        this.subs = this.customModalService.initModal(NameChangeModalComponent, { isUSI })
            .pipe(
                filter((action: boolean) => action)
            )
            .subscribe(() => this.customModalService.closeAllModals());
    }

    openBadgeDamageModal(): void {
        this.subs = this.customModalService.initModal(BadgeDamagedModalComponent)
            .pipe(
                filter((action: boolean) => action)
            )
            .subscribe(() => this.customModalService.closeAllModals());
    }

    openBadgelostModal(reasonId: number): void {
        this.subs = this.customModalService.initModal(BadgeLostModalComponent, { reasonId })
            .pipe(
                filter((action: boolean) => action)
            )
            .subscribe(() => this.customModalService.closeAllModals());
    }

    onBadgeTypeSelected(type: 'initial' | 'extension') {
        this.badgeFormType = type;
        this.showBadgeTypePopup = false;
        if (this.selectedVisitorTab) {
            // Continue normal flow for visitor tabs
            this.updateRequestReasonPayload(this.selectedVisitorTab);
        }
    }

    onBadgeTypeModalClose() {
        this.showBadgeTypePopup = false;
    }
}
